import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ModalPopupComponent } from '../components/modal-popup/modal-popup.component';

/**
 * Service to handle and display application errors to users.
 * Centralizes error handling logic and provides consistent error dialogs.
 */
@Injectable({
	providedIn: 'root'
})
export class ErrorDialogService {

	constructor(
		private readonly dialog: MatDialog,
		private readonly translateService: TranslateService
	) { }

	/**
	 * Displays an error dialog to the user and rethrows the error.
	 * @param error - The error object that occurred
	 * @param customMessage - Optional custom error message. If not provided, uses default translation key
	 * @throws Rethrows the error after displaying the dialog
	 */
	showErrorDialog(error: any, customMessage?: string): void {
		this.dialog.open(ModalPopupComponent, {
			width: 'rem(300px)',
			panelClass: 'popup',
			data: {
				popupMessage: getErrorMessage(error, this.translateService, customMessage),
				popupOk: this.translateService.instant('Common.Controls.Ok'),
				reloadOnClose: false,
				closeWindowOnOk: false
			}
		});
		throw error;
	}
}

function getErrorMessage(
	error: any, 
	translateService: TranslateService,
	customMessage?: string, 
): string {
	if (error?.status === 403) {
		if (translateService) {
			return customMessage ?? translateService?.instant('Error.CannotAccessSourceData') ?? error;
		}
	}

	return typeof error === 'string' ? error : error?.message ?? customMessage ?? 'Something went wrong. Please try again later';
}
